import { KYMW1300Component } from '../kymw1300.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1300TargetListComponent } from '../kymw1300-target-list/kymw1300-target-list.component';
import { CommonTargetModel, SelectTargetModel } from './common-target.model';
import { KYMW1300GetPlanTargetListModel } from './kymw1300-get-plan-target-list.model';
import { KYMW0002OutputModel } from 'src/app/commons/kymw00/kymw0002/vo/kymw0002-output.model';
import { KYMW0001OutputModel } from 'src/app/commons/kymw00/kymw0001/vo/kymw0001-output.model';

/**
 * 商品企画マスタ画面　選定候補一覧の値を管理する共通モデルクラス
 *
 * @export KYMW1300SelectTargetTabModel
 * @class KYMW1300SelectTargetTabModel
 */
export class KYMW1300SelectTargetTabModel {

  kymw1300Component: KYMW1300Component;
  kymw1300_02Cmp: KYMW1300TargetListComponent;

  // 画面制御用
  public selectTargetListDisplay: boolean = <boolean>true;                      // 選定候補一覧表示区分

  // 画面バインド用変数
  public orderCodeFromCatalog: string = null;                                      // 受注コード(From)
  public orderCodeToCatalog: string = null;                                        // 受注コード(To)
  public innerOrderNumQuotaList: Array<any> = new Array<any>();                    // 注文コード割当


  public totalNum: number = 0;                                               // 件数表示・総件数
  public startDispNum: number = 0;                                           // 件数表示・表示開始件数
  public endDispNum: number = 0;                                             // 件数表示・表示終了件数
  public displayItemSet: Array<any> = new Array<any>();                      // 表示項目セット
  public selectTargetList: SelectTargetModel[] = [];                         // 選定候補リスト

  // 検索条件
  public orderCode: string = null;                                              // 受注コード
  public orderNumQuotaCode: string = null;                                      // 注文コード割当
  public featureCode: string = null;                                            // 特集コード割当
  public page: string = <string>'';                                             // ページ
  public sortItem: string = null;                                               // ソート項目名
  public sortOrder: string = null;                                              // 昇順降順区分
  public startOrderCode: string = null;                                         // 開始受注コード
  public endOrderCode: string = null;                                           // 終了受注コード
  public bundleCatalogOrderCode: Array<any> = new Array<any>();                 // 束ね企画受注コード
  public catalogSearchFlg: number = <number>1;                                  // 企画検索表示フラグ（0:非表示、1:表示）

  // 検索条件・商品検索画面（ダイアログ）
  public pcode: string = null;                                                  // Ｐコード
  public itemCode: string = null;                                               // アイテムコード
  public janCode: string = null;                                                // ＪＡＮコード
  public makerName: string = null;                                              // メーカー名
  public guideGoodsNameList: Array<any> = new Array<any>();                     // 商品案内商品名リスト
  public guideStandardNameList: Array<any> = new Array<any>();                  // 商品案内規格名リスト
  public tagId: Array<any> = new Array<any>();                                  // タグ
  public tagSearchType: string = <string>'AND';                                 // タグ検索方法
  public goodsMark: Array<any> = new Array<any>();                              // 商品マーク
  public goodsMarkSearchType: string = <string>'OR';                            // 商品マーク検索方法
  public dataKbnFlg: boolean = <boolean>false;                                  // 取扱終了商品を含む
  public goodsDiv: string = null;                                               // 商品区分(false:通常商品、true:ダミー商品)
  public coopCode: Array<any> = new Array<any>();                               // 生協コードリスト
  public buyerCode: string = null;                                              // バイヤーコード
  public admitStatus: string = null;                                            // 登録レベル
  public registDateFrom: string = null;                                         // マスタ登録日(開始)
  public registDateTo: string = null;                                           // 登録日(to)
  public updateDateFrom: string = null;                                         // マスタ更新日(開始)
  public updateDateTo: string = null;                                           // マスタ更新日(終了)
  public classCode: string = null;                                              // 部門
  public middleClassCode: string = null;                                        // 中分類
  public smallClassCode: string = null;                                         // 小分類
  public ordrClientCode: string = null;                                         // 発注先コード
  public ordrClientKanji: string = null;                                        // 発注先名称
  public payeeClientCode: string = null;                                        // 支払先コード
  public payeeClientKanji: string = null;                                       // 支払先名称
  public searchMediumType: string = null;                                       // 商品検索媒体区分
  public searchOrderCode: string = null;                                        // 商品検索受注コード
  public specialFeature: string = null;                                         // 特集コード
  public catalogCode: Array<string> = new Array<string>();
  public catalogCodeSearchType: string = <string>'OR';
  public pageNo: Array<string> = new Array<string>();
  public duties: Array<string> = new Array<string>();
  public pcodeList: Array<any> = new Array<any>();                              // Ｐコードリスト
  public itemCodeList: Array<any> = new Array<any>();                           // アイテムコードリスト
  public searchKbn: number = <number>0;                                         // 検索区分（0:通常検索、1:リスト検索（Pコード）、2:リスト検索（アイテムコード））
  /** タグ再表示用 */
  public tagOutput: KYMW0002OutputModel;
  /** 商品マーク再表示用 */
  public goodsMarkOutput: KYMW0001OutputModel;
  /** 企画回再表示用 */
  public catalogId: string = <string>'';
  /** 企画マーク再表示用 */
  public catalogMarkOutput: KYMW0001OutputModel;
  /** ページ再表示用 */
  public pageInput: string = '';

  /**
   * 選定候補一覧の状態
   * 
   * value 候補一覧取得時のStatus
   * text 画面に表示する文字列
   * isSelected 選定済み
   */
  private readonly TARGET_STATUS = {
    /** "0":""  通常 */
    "0": {value: "0", text: "", isSelected: false},
    /** 1:"仮"  仮登録. */
    "1": {value: "1", text: "仮", isSelected: false},
    /** 2:"選"  表示の媒体で選定. */
    "2": {value: "2", text: "選", isSelected: true},
    /** 3:"他"  同媒体グループ区分で選定. */
    "3": {value: "3", text: "他", isSelected: true},
    /** 4:"別"  別媒体グループ区分で選定. */
    "4": {value: "4", text: "別", isSelected: true},
    /** 5:"外"  取扱期間外. */
    "9": {value: "9", text: "外", isSelected: false}
  } as const;

  constructor() {
    // 表示項目セット
    this.displayItemSet.push({ label: 'パターン１', data: '1' });
    this.displayItemSet.push({ label: 'パターン２', data: '2' });
    this.displayItemSet.push({ label: 'パターン３', data: '3' });
  }

  /**
   * 選定候補一覧のクリア処理
   *
   * @memberof KYMW1300SelectTargetTabModel
   */
  public clearList(): void {
    // 検索条件クリア
    this.orderNumQuotaCode = null;                                             // 受注コード(From)
    this.featureCode = null;                                                   // 受注コード(To)
    this.kymw1300Component.kymw1300Model.lastTimeGetSelectedListVO = null;     // 前回検索条件

    // 件数表示クリア
    this.totalNum = 0;                                                         // 件数表示・総件数
    this.startDispNum = 0;                                                     // 件数表示・表示開始件数
    this.endDispNum = 0;                                                       // 件数表示・表示終了件数

    // 選定候補一覧
    this.selectTargetList = new Array<any>();                                  // 選定候補リスト
  }

  /**
   * 選定候補一覧の反映処理
   *
   * @param data 選定候補一覧情報
   * @param vo 選定候補一覧検索条件VO
   */
  public updateSelectTargetList(data: CommonTargetModel, vo: KYMW1300GetPlanTargetListModel): void {
    // 検索条件を保持
    this.page = vo.page;                                                        // 表示開始ページ
    this.sortItem = vo.sortItem;                                                // ソート項目名
    this.sortOrder = vo.sortOrder;                                              // 昇順降順区分(ASC, DESC)

    this.orderCode = vo.orderCode;                                              // 受注コード

    // 検索条件・商品検索画面を保持
    this.pcode = vo.pcode;                                                      // Ｐコード
    this.itemCode = vo.itemCode;                                                // アイテムコード
    this.janCode = vo.janCode;                                                  // ＪＡＮコード
    this.makerName = vo.makerName;                                              // メーカー名
    this.guideGoodsNameList = vo.guideGoodsName;                                // 商品案内用商品名
    this.guideStandardNameList = vo.guideStandardName;                          // 商品案内用規格名
    this.tagId = vo.tagId;                                                      // タグ
    this.tagSearchType = vo.tagSearchType;                                      // タグ検索方法
    this.goodsMark = vo.goodsMark;                                              // 商品マーク
    this.goodsMarkSearchType = vo.goodsMarkSearchType;                          // 商品マーク検索方法
    this.dataKbnFlg = vo.dataKbnFlg;                                            // 取扱終了商品を含む
    this.goodsDiv = vo.goodsDiv;                                                // ダミー商品
    this.buyerCode = vo.buyerCode;                                              // バイヤーコード
    this.coopCode = vo.coopCode;                                                // 取扱可能生協
    this.admitStatus = vo.admitStatus;                                          // 登録レベル

    this.registDateFrom = vo.registDateFrom;                                    // 登録日(from)
    this.registDateTo = vo.registDateTo;                                        // 登録日(to)
    this.updateDateFrom = vo.updateDateFrom;                                    // 更新日(from)
    this.updateDateTo = vo.updateDateTo;                                        // 更新日(to)

    this.classCode = vo.classCode;                                              // 部門
    this.middleClassCode = vo.middleClassCode;                                  // 中分類
    this.smallClassCode = vo.smallClassCode;                                    // 小分類

    this.ordrClientCode = vo.ordrClientCode;                                    // 発注先コード
    this.ordrClientKanji = vo.ordrClientKanji;                                  // 発注先名称
    this.payeeClientCode = vo.payeeClientCode;                                  // 支払先コード
    this.payeeClientKanji = vo.payeeClientKanji;                                // 支払先名称

    this.duties = vo.duties;                                                    // デイリー

    this.searchMediumType = vo.searchMediumType;                                // 商品検索媒体区分
    this.searchOrderCode = vo.searchOrderCode;                                  // 商品検索受注コード
    this.specialFeature = vo.specialFeature;                                    // 特集コード
    this.catalogCodeSearchType = vo.catalogCodeSearchType;                      // 企画マーク検索方法
    this.catalogCode = vo.catalogCode;                                          // 企画マーク
    this.pageNo = vo.pageNo;                                                    // ページNO
    this.pcodeList = vo.pcodeList;                                              // Ｐコードリスト
    this.itemCodeList = vo.itemCodeList;                                        // アイテムコード
    this.searchKbn = vo.searchKbn;                                              // 検索区分

    this.bundleCatalogOrderCode = vo.bundleCatalogOrderCode;                    // 束ね企画受注コード 
    this.tagOutput = vo.tagOutput;                                              // タグ再表示用 
    this.goodsMarkOutput = vo.goodsMarkOutput;                                  // 商品マーク再表示用 
    this.catalogId = vo.catalogId;                                              // 企画回再表示用 
    this.catalogMarkOutput = vo.catalogMarkOutput;                              // 企画マーク再表示用 
    this.pageInput = vo.pageInput;                                              // ページ再表示用 
    // 選定候補一覧を保持
    if (data == null || data.SelectTargetList == null) {                        // 該当データなしの場合

      // 件数表示クリア
      this.totalNum = 0;                                                     // 件数表示・総件数
      this.startDispNum = 0;                                                 // 件数表示・表示開始件数
      this.endDispNum = 0;                                                   // 件数表示・表示終了件数

      // 選定候補一覧
      this.selectTargetList = [];                                            // 選定候補リスト
    } else {                                                                    // 該当データありの場合

      // 件数表示を設定
      this.totalNum = data.TotalNum;                                         // 件数表示・総件数
      this.startDispNum = data.StartDispNum;                                 // 件数表示・表示開始件数
      this.endDispNum = data.EndDispNum;                                     // 件数表示・表示終了件数

      // 選定候補一覧
      this.selectTargetList = [];                                            // 選定候補リスト

      for (let i = Number(0); i < data.SelectTargetList.length; i++) {
        this.selectTargetList.push(this.editGoodsInfo(data.SelectTargetList[i]));
      }
    }
  }

  /**
   * ステータス変更・商品選定
   * 指定のＰコードリストの商品のステータスを「2：自媒体選定」に更新する。
   *
   * @param {Array<any>} pcodeList 商品選定Ｐコードリスト
   * @memberof KYMW1300SelectTargetTabModel
   */
  public setStatus_Regist(pcodeList: Array<string>): void {
    // ステータス変更・商品選定
    for (const pCode of pcodeList) {                                            // Ｐコードリスト要素数分ループ
      for (const item of this.selectTargetList) {                               // 選定候補一覧リスト要素数分ループ
        // Ｐコードのチェック
        if (pCode === item.PCode) {                                          // 同一Ｐコードの場合
          item.Status = this.TARGET_STATUS['2'].value;                         // 「2：自媒体選定」
          item.DispStatus = this.TARGET_STATUS['2'].text;                      // 「2：自媒体選定」
          item.MediumType = this.kymw1300Component.kymw1300Model.mediumType;
          item.SellAreaCode = this.kymw1300Component.cmb_SellArea.selectedSellAreaCode;
          item.PlanClassCode = item.ClassCode;
          item.PlanMiddleClassCode = item.MiddleClassCode;
          item.PlanSmallClassCode = item.SmallClassCode;
          break;
        }
      }
    }
  }

  /**
   * ステータス変更・選定解除
   * 指定のＰコードリストの商品のステータスを「1：仮登録」「0：通常」に更新する。
   *
   * @param {Array<any>} pcodeList 選定解除Ｐコードリスト
   * @memberof KYMW1300SelectTargetTabModel
   */
  public setStatus_Delete(pcodeList: Array<string>): void {
    // ステータス変更・選定解除
    for (const pCode of pcodeList) {                                            // Ｐコードリスト要素数分ループ
      for (const item of this.selectTargetList) {                               // 選定候補一覧リスト要素数分ループ
        // Ｐコードのチェック
        if (pCode === item.PCode) {                                          // 同一Ｐコードの場合
          // 承認状態のチェック
          if (this.TARGET_STATUS['1'].value === item.AdmitStatus) {            // 「1:仮登録」の場合
            item.Status = this.TARGET_STATUS['1'].value;                       // 「1：仮登録」
            item.DispStatus = this.TARGET_STATUS['1'].text;                    // 「1：仮登録」
          } else {                                                           // 上記以外の場合
            item.Status = this.TARGET_STATUS['0'].value;                       // 「0：通常」
            item.DispStatus = this.TARGET_STATUS['0'].text;                    // 「0：通常」
          }
          item.MediumType = '';
          item.SellAreaCode = '';
          break;
        }
      }
    }
  }

  /**
   * ステータス変更
   * 指定のＰコードリストの商品のステータスを「1：仮登録」「0：通常」に更新する。
   *
   * @param {string} mediumType 媒体区分
   * @memberof KYMW1300SelectTargetTabModel
   */
  public setStatus_Change(mediumType: string): void {
    const mediumInfo = this.kymw1300Component.kymw1300Model.mediumTypeList.find(_=>_.MediumType === mediumType);
    // ステータス変更
    for (const item of this.selectTargetList) {                                 // 選定候補一覧リスト要素数分ループ
      // ステータスのチェック　未選定はスキップ
      if (!this.TARGET_STATUS[item.Status].isSelected) {
          // 次レコード読み込み
        continue;
      }

      // パラメータの媒体区分のチェック
      if (PlessViewUtilsSub.isEmpty(mediumType) || mediumType === item.MediumType) {
        // 指定なしの場合、または、同一媒体の場合
        item.Status = this.TARGET_STATUS['2'].value;      // 2　 ：自媒体選定
        item.DispStatus = this.TARGET_STATUS['2'].text;   // "選"：自媒体選定
      } else {
        let itemMediumGropuDiv = this.kymw1300Component.kymw1300Model.mediumTypeList.find(_ => _.MediumType === item.MediumType)?.MediumGroupDiv;
        if (mediumInfo?.MediumGroupDiv === itemMediumGropuDiv) {
          item.Status = this.TARGET_STATUS['3'].value;      // 3　 ：同媒体グループ区分で選定
          item.DispStatus = this.TARGET_STATUS['3'].text;   // "他"：同媒体グループ区分で選定
        } else {
          item.Status = this.TARGET_STATUS['4'].value;      // 4　 ：別媒体グループ区分で選定
          item.DispStatus = this.TARGET_STATUS['4'].text;   // "別"：別媒体グループ区分で選定
        }
      }
    }
  }

  /**
   * 選定候補商品情報書式編集
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof KYMW1300SelectTargetTabModel
   */
  private editGoodsInfo(data: SelectTargetModel): SelectTargetModel {
    const value = data.Status;
    if (value === '0' || value === '') {
      data.DispStatus = '';
    } else {
      data.DispStatus = this.TARGET_STATUS[value]?.text ?? "";
    }
    return data;
  }
}
